import React from 'react';
import { Box, Text, Title } from '@nimbus-ds/components';
import { DataList } from '@nimbus-ds/patterns';
import { useIsMobile } from 'commons/hooks';
import { useTranslationWithPrefix } from 'commons/utils';
import EmptyStateThirdSectionSkeleton from './EmptyStateThirdSectionSkeleton';

function EmptyStateThirdSection(): JSX.Element {
  const isMobile = useIsMobile();
  const { t } = useTranslationWithPrefix('emptyState.thirdSection');

  const SectionRow = ({
    topDivider = true,
    title,
    description,
  }: {
    topDivider?: boolean;
    title: string;
    description: string;
  }) => (
    <DataList.Row
      topDivider={topDivider}
      backgroundColor={isMobile ? 'transparent' : 'neutral-surface'}
      paddingLeft="none"
    >
      <Box display="flex" flexDirection="column" gap="4">
        <Title as="h4">{title}</Title>
        <Text color="neutral-textHigh">{description}</Text>
      </Box>
    </DataList.Row>
  );

  return (
    <Box display="flex" flexDirection="column" gap="10">
      <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} gap="4">
        <Box flex="2" display="flex" flexDirection="column" gap="8">
          <Title as={isMobile ? 'h3' : 'h2'}>{t('title')}</Title>
          {isMobile ? (
            <Box flex="1" display="flex" justifyContent="center">
              <img
                src="/assets/img/new-landing-arg-2.png"
                alt="Checkout"
                style={{ maxWidth: '300px' }}
              />
            </Box>
          ) : null}
          <DataList bottomDivider={false}>
            <SectionRow
              topDivider={false}
              title={t('checkoutAccelerated.title')}
              description={t('checkoutAccelerated.description')}
            />
            <SectionRow
              title={t('modo.title')}
              description={t('modo.description')}
            />
            <SectionRow
              title={t('discountForTransfers.title')}
              description={t('discountForTransfers.description')}
            />
          </DataList>
        </Box>
        {isMobile ? null : (
          <Box flex="1" display="flex" justifyContent="flex-end">
            <img
              src="/assets/img/new-landing-arg-2.png"
              alt="Checkout"
              style={{ maxWidth: '320px' }}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}

EmptyStateThirdSection.Skeleton = EmptyStateThirdSectionSkeleton;
export default EmptyStateThirdSection;
